module.exports = __webpack_public_path__ + "img/confernote_03.56530f2d.png";